<script setup lang="ts">
import ModalFromBot from "@/components/Modal/ModalFromBot.vue";
import Tabbar from "@/components/Tabbar.vue";
import WaterFall from "@/components/WaterFall.vue";
import IndexComponent from "@/components/indexComponent.vue";
import router from "@/router";
import _service from "@/service";
import { IndexBar, closeToast, showLoadingToast, showToast } from "vant";
import { computed } from "vue";
import { onMounted } from "vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import countryJson from '@/assets/country.json'
import { reactive } from "vue";
import CountryCodeSlider from "@/components/CountryCodeSlider.vue";
import { symbolByCurrency, validateEmail } from "@/utils";
import { useSystemStore } from "@/stores/system";
const isShowPayModal = ref<boolean>(false);
const isShowDetailModal = ref<boolean>(false);
const showSlider = ref<boolean>(false);
const integralActive = ref<boolean>(false);
const productCur = ref<number>(0);
const payTypeIndex = ref<number>(0);
const appUserInfo = ref<any>({});
const alphabetArray = ref<any[]>([]);
const stepNumber = ref<number>(1);
const form = reactive({
  mobileCode:'',
  receiverName:'',
  receiverMobile:'',
  email:''
})
const searchWord = ref<string>('');
const productData = ref<any>()
const payTypeList = ref([
  "Line Pay",
  "Kakao Pay",
  "PayPal",
  "Credit Card",
]);

const {t} = useI18n()

const systemStore = useSystemStore()
const globalCurrency = computed(()=>{
  return systemStore.globalCurrency
})

const handleStep = (type: string) => {
  if (type === "+") {
    if (stepNumber.value >= 99) {
      return false;
    }
    stepNumber.value++;
  } else {
    if (stepNumber.value === 1) {
      return false;
    }
    stepNumber.value--;
  }
};

onMounted(() => {
  if (sessionStorage.getItem('ORDER_CONFIRM_DATA')) {
    productData.value = JSON.parse(sessionStorage.getItem('ORDER_CONFIRM_DATA') || '')
    console.log(productData.value,'productData');
    getAppUserInfo()
  } else {
    showToast('Data Error')
  }
  if (import.meta.env.DEV) {
    form.mobileCode = '86'
    form.email = '7456456@qq.com'
    form.receiverName = '胖胖胖'
    form.receiverMobile = '15768653529'
  }
})


const payFn = () => {
  showToast('Coming soon')
}

const handleCreateOrder  =  async() => {
  if (form.receiverMobile && !form.mobileCode) {
    showToast(t('Please select regio'))
    showSlider.value = true
    return false
  }
  if (!form.email || !validateEmail(form.email)) {
    showToast(t('Please fill in the correct email address'))
    return false
  }
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    const postData = {
      items:[{
        skuId:productData.value.id,
        count:productData.value.count
      }],
      pointStatus:false,
      deliveryType:3,
      ...form,
      remark:''
    }
    const res:any = await _service.createStarOrder(postData)
    if (res.code === 400) {
      console.log(res.msg);
      return false
    }    
    const payOrderId = res.data.payOrderId
    showLoadingToast({
      message: t('The order was created successfully and payment is being redirected'),
      duration: 0,
    });
    const starData = {
      "name": productData.value.name,
      "price": productData.value.price,
      "initialPrice":productData.value.initialPrice,
      "totalPrice": productData.value.payPrice,
      "quantity": productData.value.count
    }
    sessionStorage.setItem('ORDER_DATA',JSON.stringify({starData:{...starData,totalPrice:productData.value.payPrice,quantity:productData.value.count},orderData:res.data}))
    router.push('/star-pay')
    closeToast()
  } catch (error) {
    console.log(error);
    
    showToast(t('Failed to create order'))
    closeToast()
  }
}

const getAppUserInfo = async () => {
 try {
  const {data} = await _service.getUserInfo({})
  const {mobile,regionCode} = data
  // appUserInfo.value = {
  //   receiverName:nickname,
  //   receiverMobile:mobile
  // }
  form.receiverMobile = mobile
  form.mobileCode = regionCode
 } catch (error) {
  console.log(error,'getAppUserInfo error');
  
 }
}

const getCountryCode = (code: string) => {
  form.mobileCode = code
  showSlider.value = false
}


</script>

<template>
  <div class="order-confirm-layout">
    <div class="media-375">
      <div class="body">
        <div class="product-info flex-row-start-center">
          <div class="left">
            <img :src="productData?.picUrl" alt="" />
          </div>
          <div class="right flex-col-between-start">
            <div class="title">
              {{ productData?.name }}
            </div>
            <!-- <div class="store-title flex-row-start-center">
              店铺标题店铺标题店铺标题 <span class="right-icon"></span>
            </div> -->
            <div class="store-address">
              {{ productData?.address }}
            </div>
          </div>
        </div>
        <div class="product-sku">
          <p>{{ productData?.valueName }}</p>
          <p class="fs-12">{{symbolByCurrency[productData?.priceSymbol]}}<span class="number-font"> {{ productData?.price }}</span> x{{ productData?.count }}</p>
          <div class="fs-12 order-tip">
            <p class="item-wrap" v-if="!productData?.refundEnabled">
              <i class="icon"></i>{{ t('No refunds') }}
            </p>
            <p class="item-wrap">
              <i class="icon" :class="productData?.transferEnabled ? 'transfer' : 'notransfer'"></i>{{ productData?.transferEnabled ?  t('Transferable') : t('Not transferable') }}
            </p>
          </div>
        </div>
        
        <div class="write-off flex-col-start-start">
          <div class="wrapper">
            <p>{{t('Delivery method')}}</p>
            <div class="code">
              <div class="flex-row-start-center">{{t('E-ticket')}} <span class="tag">{{t('Direct entry')}}</span></div>
              <div class="tip">{{ t('After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher') }}</div>
            </div>
          </div>
          <div class="wrapper">
            <p>{{t('Contact person')}}</p>
            <div class="inputer">
              <span class="name">{{t('Name')}}</span> <input type="text" v-model="form.receiverName" :placeholder="t('Please fill in the contact name')">
            </div>
            <div class="inputer">
              <span class="code-input" @click="showSlider = true">
                <span class="text">{{ form.mobileCode ? `+${form.mobileCode}` : t('Region') }}</span> <i class="drop-down-icon"></i> </span>
              <input type="number" :placeholder="t('Please enter the mobile number')" v-model="form.receiverMobile" @input="(e: any) => {
                const validPattern = /^[0-9]*$/;
                if (!validPattern.test(e.target.value)) {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }
              }">
            </div>
            <div class="inputer">
              <span class="name">{{t('Email')}}</span> <input type="text" v-model="form.email" :placeholder="t('Please fill in the email')">
              <span class="email-tip">{{t('The ticket verification code will be sent to your email via')}}</span>
            </div>
          </div>
          <div class="logo"></div>
        </div>
      </div>
      <div class="submit-area media-375">
        <!-- <div
          class="integral flex-row-start-center"
          :class="{ active: integralActive }"
          @click="integralActive = !integralActive"
        >
          <span class="radius"></span> 使用*** STAR 抵扣 $***
        </div> -->
        <div class="flex-row-between-center">
          <div class="price flex-row-start-end">
            <span class="flex-row-start-end">{{symbolByCurrency[productData?.priceSymbol]}}<span class="number-font"> {{ (+productData?.payPrice).toFixed(2) }}</span></span>
            <span class="text flex-row-start-center" @click="isShowDetailModal = true">{{t('Details')}} <span
                class="expand-icon"></span></span>
          </div>
          <div class="submit-btn flex-row-center-center" @click="handleCreateOrder">
            {{t('Submit order')}}
          </div>
        </div>
      </div>
      <ModalFromBot v-model:is-show="isShowPayModal">
        <div class="pay-modal flex-col-center-center">
          <p class="title">{{t('Select Payment Method')}}</p>
          <div class="pay-type-list">
            <div class="pay-type-list-item flex-row-between-center" v-for="(item, index) in payTypeList" :key="index"
              @click="payTypeIndex = index" :class="{ active: payTypeIndex === index }">
              <p class="flex-row-start-center">
                <span class="circle"></span> <span>{{ item }}</span>
              </p>
              <p class="check"></p>
            </div>
          </div>
          <div class="pay-area flex-row-between-center">
            <p>{{symbolByCurrency[productData?.priceSymbol]}} <span class="number-font"> {{ productData?.payPrice }}</span></p>
            <div class="pay-btn" @click="payFn">{{t('Pay')}}</div>
          </div>
        </div>
      </ModalFromBot>
      <ModalFromBot v-model:is-show="isShowDetailModal">
        <div class="detail-modal flex-col-center-center">
          <div class="title">
            {{t('Price details')}}
            <p class="second-title">{{t('The actual discount amount is subject to the following single page')}}</p>
          </div>
          <div class="product-info">
            <div class="main flex-row-between-center">
              <p>{{t('Product information')}}</p>
              <p class="flex-row-start-end">{{symbolByCurrency[productData?.priceSymbol]}}<span class="number-font">{{ productData?.payPrice }}</span></p>
            </div>
            <div class="gray flex-row-between-center">
              <p>{{symbolByCurrency[productData?.priceSymbol]}}{{ productData?.price || 0 }}×{{ productData?.count }}</p>
              <p>{{symbolByCurrency[productData?.priceSymbol]}}{{ productData?.payPrice }}</p>
            </div>
          </div>
          <div class="product-info discount" v-if="integralActive">
            <div class="main flex-row-between-center">
              <p>{{t('STAR deduction')}}</p>
              <p class="flex-row-start-end">- <span class="number-font">0</span></p>
            </div>
            <div cl ass="gray flex-row-between-center">
              <p>-**star</p>
              <p></p>
            </div>
          </div>
          <div class="confirm-area flex-row-between-center">
            <div class="price flex-row-start-end">
              <p class="flex-row-start-end">{{symbolByCurrency[productData?.priceSymbol]}}<span class="number-font"> {{ productData?.payPrice }}</span></p>
              <p class="text flex-row-start-center" @click="isShowDetailModal = false">{{t('Details')}} <span class="expand-icon"></span></p>
            </div>
            <div class="confirm-btn flex-row-center-center" @click="isShowDetailModal = false">
              {{t('Confirm')}}
            </div>
          </div>
        </div>
      </ModalFromBot>
      <CountryCodeSlider @selectCode="getCountryCode" v-model:is-show="showSlider"></CountryCodeSlider>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.order-confirm-layout {
  height: 100%;
  min-height: 100vh;
  background: #000;

  .body {
    padding: 14px 16px;
    color: #fff;
    height: calc(100vh - 84px);
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    .product-info {
      height: 122px;
      gap: 12px;

      .left {
        img {
          width: 96px;
          height: 122px;
          border-radius: 12px;
          background: #d9d9d9;
          object-fit: cover;
        }
      }

      .right {
        height: 100%;

        .title {
          font-size: 14px;
          line-height: 1.6;

          .tag {
            font-size: 8px;
            display: inline-flex;
            padding: 3px 4px;
            justify-content: center;
            align-items: center;
            bottom: 2px;
            gap: 2px;
            border-radius: 4px;
            margin-right: 6px;
            background: linear-gradient(224deg,
                #eaadff 0%,
                #efdbff 44.6%,
                #76d6ff 98.01%);
          }
        }

        .store-title {
          font-size: 12px;

          .right-icon {
            width: 16px;
            height: 16px;
            background: url(../../assets/right-icon-white.svg);
            background-repeat: no-repeat;
            background-size: contain;
            margin-left: 4px;
          }
        }

        .store-address {
          line-height: 1.2;
          font-size: 11px;
          color: #565662;
          overflow: hidden;
          text-overflow: ellipsis;
          /* 将对象作为弹性伸缩盒子模型显示 */
          display: -webkit-box;
          /* 限制在一个块元素显示的文本的行数 */
          /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
          -webkit-line-clamp: 2;
          /* 设置或检索伸缩盒对象的子元素的排列方式 */
          -webkit-box-orient: vertical;
        }

        .price {
          color: #ff3456;
          font-size: 21px;

          .coin {
            font-size: 12px;
            margin-right: 2px;
          }
        }
      }
    }

    .product-sku {
      padding: 12px 0;
      border-top: 1px solid rgba($color: #eee, $alpha: 0.1);
      margin-top: 12px;
      font-size: 16px;
      color: #fff;
      line-height: 1.6;

      .number-font {
        font-size: 16px;
      }
      .order-tip{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap:16px;
        margin-top: 10px;
        .item-wrap{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap:4px;
        }
        .icon{
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(../../assets/x-circle.svg);
          background-size: contain;
          background-repeat: no-repeat;
          &.transfer{
            background: url(../../assets/transfer.png);
            background-size: contain;
            background-repeat: no-repeat;
          }
          &.notransfer{
            background: url(../../assets/no_transfer.png);
            background-size: contain;
            background-repeat: no-repeat;
          }
        }
      }
    }
    
    .write-off {
      position: relative;
      width: 100%;
      height: 475px;
      background: url(../../assets/card-back.png);
      background-size: cover;
      background-repeat: no-repeat;
      padding: 24px 16px;
      border-radius: 16px;
      color: #565662;
      font-size: 12px;
      gap: 16px;
      .wrapper{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 12px;
        .inputer{
          position: relative;
          width: 100%;
          height: 52px;
          border-radius: 12px;
          background: #FFF;
          display: flex;
          align-items: center;
          padding: 18px 16px;
          justify-content: space-between;
          color: #000;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px; /* 114.286% */
          .email-tip{
            position: absolute;
            bottom: -22px;
            right: 0px;
            font-size: 12px;
            color: red;
          }
          .text {
            width: 100px;
            cursor: pointer;
            text-align: right;
            &.disabled{
              pointer-events: none;
              opacity: 0.6;
            }
          }

          .code-input {
            position: relative;
            color: #000;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-weight: 500;
            margin-right: 15px;

            .text {
              width: max-content;
            }

            &::after {
              display: block;
              content: "";
              width: 1px;
              height: 18px;
              background: rgba(255, 255, 255, 0.10);
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
            }

            .drop-down-icon {
              width: 24px;
              height: 24px;
              background: url(../../assets/drop-down-icon.svg);
              background-size: contain;
              background-repeat: no-repeat;
              margin-right: 4px;
            }
          }
          input{
            text-align: right;
            &::placeholder{
              color: #DDD;
            }
          }
          .name{
            width: 100px;
          }
        }
      }
      .code {
        width: 100%;
        display: flex;
        padding: 12px 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        border-radius: 12px;
        background: #FFF;
        color: #000;
        font-size: 16px;
        font-weight: 500;
        margin-top: 12px;

        .tag {
          display: flex;
          padding: 4px 8px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: 4px;
          border: 1px solid #4BFCC8;
          font-family: "PingFang SC";
          font-size: 10px;
          font-weight: 500;
          line-height: normal;
          background: linear-gradient(137deg, #4BFCC8 2.92%, #49FA86 9.01%, #39E7FF 96.65%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-left: 12px;
        }

        .tip {
          color: #999;
          font-size: 12px;
          margin-top: 4px;
          font-weight: 400;
          line-height: 16px;
          /* 133.333% */
        }
      }

      .logo {
        position: absolute;
        bottom: 36px;
        left: 50%;
        transform: translateX(-50%);
        width: 57px;
        height: 24px;
        background: url(../../assets/opacity-logo.svg);
        background-size: contain;
        background-repeat: no-repeat;
        opacity: 0.1;
      }
    }
  }

  .submit-area {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px 16px;

    .integral {
      color: #fff853;
      font-size: 12px;
      margin-bottom: 12px;

      .radius {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #fff;
        margin-right: 8px;
      }

      &.active {
        .radius {
          background: url(../../assets/select.svg);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }

    .price {
      font-size: 12px;
      color: #ff3456;
      line-height: normal;

      .number-font {
        font-size: 21px;
        margin-left: 2px;
      }

      .text {
        color: #9c9caa;
        margin-left: 6px;

        .expand-icon {
          width: 16px;
          height: 16px;
          background: url(../../assets/back-icon-white.svg);
          background-repeat: no-repeat;
          background-size: contain;
          margin-left: 4px;
          transform: rotate(90deg);
        }
      }
    }

    .submit-btn {
      @include button;
    }
  }
}

.pay-modal {
  gap: 24px;
  padding: 24px 16px;

  .title {
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }

  .pay-type-list {
    width: 100%;

    &-item {
      width: 100%;
      height: 52px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      border-bottom: 0.5px solid #545769;

      &.active {
        .check {
          display: block;
        }
      }

      .check {
        display: none;
        width: 16px;
        height: 16px;
        background: url(../../assets/check.svg);
        background-repeat: no-repeat;
        background-size: contain;
      }

      .circle {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #50bf8c;
        margin-right: 6px;
      }
    }
  }

  .pay-area {
    width: 100%;
    font-size: 12px;
    color: #ff3456;

    .number-font {
      font-size: 21px;
    }

    .pay-btn {
      @include button;
    }
  }
}

.detail-modal {
  width: 100%;
  padding: 24px 16px;
  gap: 24px;

  .title {
    font-size: 18px;
    color: #fff;
    font-weight: 500;

    .second-title {
      margin-top: 10px;
      color: #9C9CAA;
      font-size: 13px;
    }
  }

  .product-info {
    width: 100%;

    .main {
      font-size: 12px;
      color: #fff;
      font-weight: 700;
      line-height: normal;

      .number-font {
        font-weight: 700;
        font-size: 16px;
        margin-left: 2px;
      }
    }

    .gray {
      color: #999;
      font-size: 12px;
      font-weight: 400;
      margin-top: 5px;
    }
  }

  .confirm-area {
    width: 100%;

    .price {
      font-size: 12px;
      color: #ff3456;
      line-height: normal;

      .number-font {
        font-size: 21px;
        margin-left: 2px;
      }

      .text {
        color: #9c9caa;
        margin-left: 6px;

        .expand-icon {
          width: 16px;
          height: 16px;
          background: url(../../assets/back-icon-white.svg);
          background-repeat: no-repeat;
          background-size: contain;
          margin-left: 4px;
          transform: rotate(90deg);
        }
      }
    }

    .confirm-btn {
      @include button;
    }
  }
}
</style>
